export enum EKeyboardKey {
	ESCAPE = 'Escape',
	ENTER = 'Enter',
	BACKSPACE = 'Backspace',
	DELETE = 'Delete',
	ARROW_LEFT = 'ArrowLeft',
	ARROW_RIGHT = 'ArrowRight',
}
